import React from "react";

export default function ProphetMuhammadFrame5({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-prop51{fill:#af8e02}.cls-prop52{fill:#aa38c6}.cls-prop53{fill:#811d99}.cls-prop54{fill:#e0bf36}.cls-prop55{fill:#9729b2}.cls-prop56{fill:#c19d05}"
            }
          </style>
        </defs>
        <path
          d="M423.47 1280.1h7v6h-7zM423.46 1267.78v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64V910.5h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99Zm-.02-24.64v-12.32h6.99v12.32h-6.99ZM423.06 842.87h7v6h-7zM906.747 1528.071l7-.018.019 7.05-7 .018zM906.67 1513.72l-.04-14.38 7-.02.04 14.38-7 .02Zm-.07-28.76-.04-14.38 7-.02.04 14.38-7 .02Zm-.07-28.76-.04-14.38 7-.02.04 14.38-7 .02Zm-.07-28.76-.04-14.38 7-.02.04 14.38-7 .02Zm-.07-28.76-.04-14.38 7-.02.04 14.38-7 .02Zm-.07-28.76-.04-14.38 7-.02.04 14.38-7 .02Zm-.07-28.76-.04-14.38 7-.02.04 14.38-7 .02Zm-.07-28.76-.04-14.38 7-.02.04 14.38-7 .02Zm-.07-28.76-.04-14.38 7-.02.04 14.38-7 .02Zm-.07-28.75-.04-14.38 7-.02.04 14.38-7 .02ZM905.978 1219.054l7-.018.019 7.05-7 .018zM1480.301 1368.29l7-.037.04 7.19-7 .038zM1480.22 1354.46l-.07-13.86 7-.04.07 13.86-7 .04Zm-.15-27.71-.07-13.86 7-.04.07 13.86-7 .04Zm-.15-27.71-.07-13.86 7-.04.07 13.86-7 .04Zm-.15-27.71-.07-13.86 7-.04.07 13.86-7 .04Zm-.15-27.71-.07-13.86 7-.04.07 13.86-7 .04Zm-.15-27.71-.07-13.86 7-.04.07 13.86-7 .04Zm-.15-27.71-.07-13.86 7-.04.07 13.86-7 .04ZM1479.148 1153.25l7-.038.039 7.19-7 .038z"
          className="cls-prop54"
        />
        <path
          d="M1658.97 882.1c-42.4 319.55-315.95 566.1-647.08 566.1-360.53 0-652.79-292.27-652.79-652.79 0-287.63 186.03-531.82 444.34-618.79-141.85 104.09-233.93 272.01-233.93 461.43 0 315.91 256.1 572 572 572 228.61 0 425.9-134.11 517.47-327.95Z"
          className="cls-prop54"
        />
        <path
          d="M1638.81 977.94c-78.96 271.7-329.76 470.26-626.93 470.26-360.52 0-652.79-292.26-652.79-652.79 0-232.27 121.31-436.22 304.04-551.91-125.87 117.77-205.09 288.9-205.09 479.36 0 355.24 275.59 643.23 615.54 643.23 253.23 0 470.74-159.79 565.23-388.15Z"
          className="cls-prop56"
        />
        <path
          d="M1141.5 1215.85c-78 0-153.67-15.28-224.9-45.41-68.8-29.1-130.59-70.76-183.65-123.82-53.06-53.06-94.72-114.85-123.82-183.65-30.13-71.24-45.41-146.9-45.41-224.9S579 484.4 609.13 413.17c29.1-68.8 70.76-130.59 123.82-183.66 53.06-53.06 114.85-94.72 183.65-123.82 71.24-30.13 146.9-45.41 224.9-45.41s153.67 15.28 224.9 45.41c68.8 29.1 130.59 70.76 183.65 123.82 53.06 53.06 94.72 114.85 123.82 183.66 30.13 71.24 45.41 146.9 45.41 224.9s-15.28 153.67-45.41 224.9c-29.1 68.8-70.76 130.59-123.82 183.65-53.06 53.06-114.85 94.72-183.65 123.82-71.24 30.13-146.9 45.41-224.9 45.41Zm0-1144c-312.21 0-566.22 254-566.22 566.22s254 566.22 566.22 566.22 566.22-254 566.22-566.22-254-566.23-566.22-566.23ZM1248.53 1489.74l20.45 41.45 45.74 6.65-33.1 32.26 7.81 45.55-40.9-21.51-40.91 21.51 7.81-45.55-33.09-32.26 45.73-6.65 20.46-41.45zM1632.44 1255.95l15.85 32.12 35.45 5.15-25.65 25 6.05 35.31-31.7-16.67-31.7 16.67 6.05-35.31-25.65-25 35.45-5.15 15.85-32.12zM642.82 1560l15.85 32.11 35.45 5.15-25.65 25.01 6.06 35.3-31.71-16.67-31.7 16.67 6.05-35.3-25.64-25.01 35.44-5.15 15.85-32.11zM332.01 1088.17l15.85 32.11 35.44 5.15-25.64 25.01 6.05 35.3-31.7-16.67-31.71 16.67 6.06-35.3-25.65-25.01 35.45-5.15 15.85-32.11zM1100.47 1673.29l12.68 25.69 28.35 4.12-20.52 20 4.85 28.24-25.36-13.33-25.37 13.33 4.85-28.24-20.52-20 28.36-4.12 12.68-25.69zM799.75 1461.43l12.68 25.7 28.36 4.12-20.52 20 4.84 28.24-25.36-13.33-25.36 13.33 4.84-28.24-20.51-20 28.35-4.12 12.68-25.7zM318.05 971.41l9.89 20.04 22.11 3.21-16 15.6 3.78 22.02-19.78-10.4-19.77 10.4 3.77-22.02-16-15.6 22.12-3.21 9.88-20.04zM569.5 1358.27l9.89 20.04 22.11 3.21-16 15.6 3.78 22.02-19.78-10.39-19.78 10.39 3.78-22.02-16-15.6 22.11-3.21 9.89-20.04z"
          className="cls-prop54"
        />
        <path
          d="M994.47 1583.32c0-5.82-4.11-10.85-9.83-11.97-12.11-2.36-31.84-8.71-48.7-26.3a88.978 88.978 0 0 1-15.35-21.74c-4.42-8.81-16.87-9.13-21.59-.48a95.865 95.865 0 0 1-15.09 20.59c-17.2 17.91-37.03 24.86-49.26 27.62-5.55 1.26-9.48 6.2-9.48 11.89v43.41h169.3v-43.04Z"
          className="cls-prop55"
        />
        <path
          d="M994.47 1583.32v43.04h-169.3v-8.13h159.55v-29.63c0-4.01-4.11-7.47-9.83-8.24-12.12-1.62-31.84-6-48.7-18.1-6.78-4.87-11.73-10-15.35-14.97-4.42-6.07-16.87-6.28-21.6-.33-3.72 4.69-8.62 9.54-15.09 14.18-16.91 12.12-36.37 16.95-48.64 18.93a12.17 12.17 0 0 1 9.14-9.01c12.23-2.77 32.06-9.72 49.26-27.62a95.91 95.91 0 0 0 15.09-20.6c4.72-8.65 17.17-8.33 21.59.48a88.978 88.978 0 0 0 15.35 21.74c16.86 17.58 36.58 23.94 48.69 26.3 5.72 1.11 9.83 6.14 9.83 11.96Z"
          className="cls-prop53"
        />
        <rect
          width={220.14}
          height={29.27}
          x={799.75}
          y={1605.77}
          className="cls-prop56"
          rx={14.63}
          ry={14.63}
        />
        <path
          d="M1019.79 1620.4c0 8.08-6.55 14.63-14.64 14.63H814.28c-4.04 0-7.7-1.63-10.35-4.28a14.307 14.307 0 0 1-3.01-4.39h194.07c5.61 0 10.16-4.55 10.16-10.16 0-2.81-1.14-5.34-2.98-7.19a10.11 10.11 0 0 0-7.18-2.98H811.48c.91-.18 1.84-.27 2.8-.27h190.87c4.04 0 7.7 1.64 10.35 4.29 2.65 2.65 4.29 6.31 4.29 10.35Z"
          className="cls-prop51"
        />
        <path
          d="M994.47 1635.04h-169.3v186.18h169.3v-186.18z"
          className="cls-prop54"
        />
        <path
          d="M994.47 1872.93c0 5.82-4.11 10.85-9.83 11.97-12.11 2.36-31.84 8.71-48.7 26.3a88.978 88.978 0 0 0-15.35 21.74c-4.42 8.81-16.87 9.13-21.59.48a95.865 95.865 0 0 0-15.09-20.59c-17.2-17.91-37.03-24.86-49.26-27.62-5.55-1.26-9.48-6.2-9.48-11.89v-43.41h169.3v43.04Z"
          className="cls-prop55"
        />
        <path
          d="M994.47 1872.93v-43.04h-169.3v8.13h159.55v29.63c0 4.01-4.11 7.47-9.83 8.24-12.12 1.62-31.84 6-48.7 18.1-6.78 4.87-11.73 10-15.35 14.97-4.42 6.07-16.87 6.28-21.6.33-3.72-4.69-8.62-9.54-15.09-14.18-16.91-12.12-36.37-16.95-48.64-18.93a12.17 12.17 0 0 0 9.14 9.01c12.23 2.77 32.06 9.72 49.26 27.62a95.91 95.91 0 0 1 15.09 20.6c4.72 8.65 17.17 8.33 21.59-.48a88.978 88.978 0 0 1 15.35-21.74c16.86-17.58 36.58-23.94 48.69-26.3 5.72-1.11 9.83-6.14 9.83-11.96Z"
          className="cls-prop53"
        />
        <rect
          width={220.14}
          height={29.27}
          x={799.75}
          y={1821.22}
          className="cls-prop56"
          rx={14.63}
          ry={14.63}
        />
        <path
          d="M825.17 1660.85h2.67c19.06 0 34.53 15.47 34.53 34.53v65.49c0 19.06-15.47 34.53-34.53 34.53h-2.67v-134.56Z"
          className="cls-prop56"
        />
        <path
          d="M862.36 1695.38v65.5c0 19.07-15.46 34.53-34.53 34.53h-2.66v-5.03c16.2-2.26 28.66-16.16 28.66-32.98v-58.53c0-16.82-12.46-30.72-28.66-32.98v-5.03h2.66c19.07 0 34.53 15.46 34.53 34.53Z"
          className="cls-prop51"
        />
        <path
          d="M994.47 1795.41h-2.77c-19.11 0-34.62-15.51-34.62-34.62v-65.32c0-19.11 15.51-34.62 34.62-34.62h2.77v134.56Z"
          className="cls-prop56"
        />
        <path
          d="M1019.89 1835.85c0-8.08-6.55-14.63-14.64-14.63H814.38c-4.04 0-7.7 1.63-10.35 4.28a14.307 14.307 0 0 0-3.01 4.39h194.07c5.61 0 10.16 4.55 10.16 10.16 0 2.81-1.14 5.34-2.98 7.19a10.11 10.11 0 0 1-7.18 2.98H811.58c.91.18 1.84.27 2.8.27h190.87c4.04 0 7.7-1.64 10.35-4.29s4.29-6.31 4.29-10.35ZM957.18 1695.38v65.5c0 19.07 15.46 34.53 34.53 34.53h2.66v-5.03c-16.2-2.26-28.66-16.16-28.66-32.98v-58.53c0-16.82 12.46-30.72 28.66-32.98v-5.03h-2.66c-19.07 0-34.53 15.46-34.53 34.53Z"
          className="cls-prop51"
        />
        <path
          d="M909.82 1662.01c-16.69 0-30.21 13.53-30.21 30.21v71.81c0 16.69 13.53 30.21 30.21 30.21 16.69 0 30.21-13.53 30.21-30.21v-71.81c0-16.69-13.53-30.21-30.21-30.21Z"
          className="cls-prop56"
        />
        <path
          d="M909.73 1662.01c-16.69 0-30.21 13.53-30.21 30.21v71.8c0 16.69 13.53 30.21 30.21 30.21 8.34 0 15.9-3.38 21.36-8.85 5.47-5.47 8.85-13.02 8.85-21.36v-71.8c0-16.69-13.52-30.21-30.21-30.21Zm24.23 93.11c0 6.69-2.71 12.75-7.1 17.13s-10.44 7.1-17.14 7.1c-13.39 0-24.23-10.85-24.23-24.23v-57.6c0-13.38 10.85-24.24 24.23-24.24s24.23 10.85 24.23 24.24v57.6Z"
          className="cls-prop51"
        />
        <ellipse
          cx={893.32}
          cy={1584.63}
          className="cls-prop52"
          rx={24.77}
          ry={7.72}
        />
        <ellipse
          cx={893.32}
          cy={1871.63}
          className="cls-prop52"
          rx={24.77}
          ry={7.72}
        />
        <path
          d="M1538.66 1373.92c0-3.84-2.71-7.15-6.48-7.89-7.98-1.55-20.98-5.74-32.09-17.33a58.784 58.784 0 0 1-10.12-14.33c-2.91-5.81-11.12-6.02-14.23-.31a63.458 63.458 0 0 1-9.94 13.57c-11.33 11.8-24.4 16.38-32.46 18.2a8.035 8.035 0 0 0-6.25 7.84v28.61h111.57v-28.36Z"
          className="cls-prop55"
        />
        <path
          d="M1538.66 1373.92v28.36h-111.57v-5.36h105.14v-19.53c0-2.64-2.71-4.92-6.48-5.43-7.98-1.07-20.98-3.95-32.09-11.93-4.47-3.21-7.73-6.59-10.11-9.86-2.91-4-11.12-4.14-14.23-.22-2.45 3.09-5.68 6.29-9.94 9.34-11.14 7.99-23.96 11.17-32.05 12.47.71-2.91 3-5.25 6.02-5.94 8.06-1.83 21.13-6.4 32.46-18.2 4.26-4.44 7.49-9.08 9.95-13.57 3.11-5.7 11.31-5.49 14.23.31 2.39 4.75 5.65 9.67 10.12 14.33 11.11 11.59 24.1 15.77 32.09 17.33 3.77.73 6.48 4.05 6.48 7.88Z"
          className="cls-prop53"
        />
        <rect
          width={145.07}
          height={19.29}
          x={1410.34}
          y={1388.71}
          className="cls-prop56"
          rx={9.64}
          ry={9.64}
        />
        <path
          d="M1555.34 1398.35c0 5.33-4.32 9.64-9.65 9.64h-125.78a9.647 9.647 0 0 1-8.81-5.71h127.89c3.7 0 6.69-3 6.69-6.7 0-1.85-.75-3.52-1.96-4.74a6.665 6.665 0 0 0-4.73-1.96h-120.93c.6-.12 1.21-.18 1.85-.18h125.78c2.66 0 5.07 1.08 6.82 2.83s2.83 4.16 2.83 6.82Z"
          className="cls-prop51"
        />
        <path
          d="M1538.66 1408h-111.57v122.69h111.56v-37.51h.01V1408z"
          className="cls-prop54"
        />
        <path
          d="M1538.66 1564.76c0 3.84-2.71 7.15-6.48 7.89-7.98 1.55-20.98 5.74-32.09 17.33a58.784 58.784 0 0 0-10.12 14.33c-2.91 5.81-11.12 6.02-14.23.31a63.458 63.458 0 0 0-9.94-13.57c-11.33-11.8-24.4-16.38-32.46-18.2a8.035 8.035 0 0 1-6.25-7.84v-28.61h111.57v28.36Z"
          className="cls-prop55"
        />
        <path
          d="M1538.66 1564.77v-28.36h-111.57v5.36h105.14v19.53c0 2.64-2.71 4.92-6.48 5.43-7.98 1.07-20.98 3.95-32.09 11.93-4.47 3.21-7.73 6.59-10.11 9.86-2.91 4-11.12 4.14-14.23.22-2.45-3.09-5.68-6.29-9.94-9.34-11.14-7.99-23.96-11.17-32.05-12.47.71 2.91 3 5.25 6.02 5.94 8.06 1.83 21.13 6.4 32.46 18.2 4.26 4.44 7.49 9.08 9.95 13.57 3.11 5.7 11.31 5.49 14.23-.31 2.39-4.75 5.65-9.67 10.12-14.33 11.11-11.59 24.1-15.77 32.09-17.33 3.77-.73 6.48-4.05 6.48-7.88Z"
          className="cls-prop53"
        />
        <rect
          width={145.07}
          height={19.29}
          x={1410.34}
          y={1530.69}
          className="cls-prop56"
          rx={9.64}
          ry={9.64}
        />
        <path
          d="M1427.09 1425.01h1.76c12.56 0 22.75 10.2 22.75 22.75v43.16c0 12.56-10.2 22.75-22.75 22.75h-1.76V1425Z"
          className="cls-prop56"
        />
        <path
          d="M1451.6 1447.76v43.16c0 12.57-10.19 22.75-22.75 22.75h-1.76v-3.32c10.67-1.49 18.89-10.65 18.89-21.73v-38.57c0-11.08-8.21-20.25-18.89-21.73V1425h1.76c12.57 0 22.75 10.19 22.75 22.75Z"
          className="cls-prop51"
        />
        <path
          d="M1538.65 1513.67h-1.82c-12.59 0-22.81-10.22-22.81-22.81v-43.04c0-12.59 10.22-22.81 22.81-22.81h1.82v88.67Z"
          className="cls-prop56"
        />
        <path
          d="M1555.41 1540.33c0-5.33-4.32-9.64-9.65-9.64h-125.78a9.647 9.647 0 0 0-8.81 5.71h127.89c3.7 0 6.69 3 6.69 6.7 0 1.85-.75 3.52-1.96 4.74a6.665 6.665 0 0 1-4.73 1.96h-120.93c.6.12 1.21.18 1.85.18h125.78c2.66 0 5.07-1.08 6.82-2.83a9.614 9.614 0 0 0 2.83-6.82ZM1514.08 1447.76v43.16c0 12.57 10.19 22.75 22.75 22.75h1.76v-3.32c-10.67-1.49-18.89-10.65-18.89-21.73v-38.57c0-11.08 8.21-20.25 18.89-21.73V1425h-1.76c-12.57 0-22.75 10.19-22.75 22.75Z"
          className="cls-prop51"
        />
        <path
          d="M1482.87 1425.77c-11 0-19.91 8.91-19.91 19.91V1493c0 11 8.91 19.91 19.91 19.91s19.91-8.91 19.91-19.91v-47.32c0-11-8.91-19.91-19.91-19.91Z"
          className="cls-prop56"
        />
        <path
          d="M1482.81 1425.77c-11 0-19.91 8.91-19.91 19.91V1493c0 11 8.91 19.91 19.91 19.91 5.5 0 10.47-2.23 14.08-5.83 3.6-3.6 5.83-8.58 5.83-14.08v-47.32c0-11-8.91-19.91-19.91-19.91Zm15.97 61.36c0 4.41-1.79 8.4-4.68 11.29s-6.88 4.68-11.29 4.68c-8.82 0-15.97-7.15-15.97-15.97v-37.96c0-8.82 7.15-15.97 15.97-15.97s15.97 7.15 15.97 15.97v37.96Z"
          className="cls-prop51"
        />
        <ellipse
          cx={1472}
          cy={1374.78}
          className="cls-prop52"
          rx={16.33}
          ry={5.09}
        />
        <ellipse
          cx={1472}
          cy={1563.9}
          className="cls-prop52"
          rx={16.33}
          ry={5.09}
        />
        <path
          d="M482.61 1317.83c0-3.84-2.71-7.15-6.48-7.89-7.98-1.55-20.98-5.74-32.09-17.33a58.784 58.784 0 0 1-10.12-14.33c-2.91-5.81-11.12-6.02-14.23-.31a63.458 63.458 0 0 1-9.94 13.57c-11.33 11.8-24.4 16.38-32.46 18.2a8.035 8.035 0 0 0-6.25 7.84v28.61h111.57v-28.36Z"
          className="cls-prop55"
        />
        <path
          d="M482.61 1317.83v28.36H371.04v-5.36h105.14v-19.53c0-2.64-2.71-4.92-6.48-5.43-7.98-1.07-20.98-3.95-32.09-11.93-4.47-3.21-7.73-6.59-10.11-9.86-2.91-4-11.12-4.14-14.23-.22-2.45 3.09-5.68 6.29-9.94 9.34-11.14 7.99-23.96 11.17-32.05 12.47.71-2.91 3-5.25 6.02-5.94 8.06-1.83 21.13-6.4 32.46-18.2 4.26-4.44 7.49-9.08 9.95-13.57 3.11-5.7 11.31-5.49 14.23.31 2.39 4.75 5.65 9.67 10.12 14.33 11.11 11.59 24.1 15.77 32.09 17.33 3.77.73 6.48 4.05 6.48 7.88Z"
          className="cls-prop53"
        />
        <rect
          width={145.07}
          height={19.29}
          x={354.3}
          y={1332.62}
          className="cls-prop56"
          rx={9.64}
          ry={9.64}
        />
        <path
          d="M499.3 1342.27c0 5.33-4.32 9.64-9.65 9.64H363.87a9.647 9.647 0 0 1-8.81-5.71h127.89c3.7 0 6.69-3 6.69-6.7 0-1.85-.75-3.52-1.96-4.74a6.665 6.665 0 0 0-4.73-1.96H362.02c.6-.12 1.21-.18 1.85-.18h125.78c2.66 0 5.07 1.08 6.82 2.83s2.83 4.16 2.83 6.82Z"
          className="cls-prop51"
        />
        <path
          d="M482.61 1351.91H371.05v122.69h111.56v-122.69z"
          className="cls-prop54"
        />
        <path
          d="M482.61 1508.68c0 3.84-2.71 7.15-6.48 7.89-7.98 1.55-20.98 5.74-32.09 17.33a58.784 58.784 0 0 0-10.12 14.33c-2.91 5.81-11.12 6.02-14.23.31a63.458 63.458 0 0 0-9.94-13.57c-11.33-11.8-24.4-16.38-32.46-18.2a8.035 8.035 0 0 1-6.25-7.84v-28.61h111.57v28.36Z"
          className="cls-prop55"
        />
        <path
          d="M482.61 1508.68v-28.36H371.04v5.36h105.14v19.53c0 2.64-2.71 4.92-6.48 5.43-7.98 1.07-20.98 3.95-32.09 11.93-4.47 3.21-7.73 6.59-10.11 9.86-2.91 4-11.12 4.14-14.23.22-2.45-3.09-5.68-6.29-9.94-9.34-11.14-7.99-23.96-11.17-32.05-12.47.71 2.91 3 5.25 6.02 5.94 8.06 1.83 21.13 6.4 32.46 18.2 4.26 4.44 7.49 9.08 9.95 13.57 3.11 5.7 11.31 5.49 14.23-.31 2.39-4.75 5.65-9.67 10.12-14.33 11.11-11.59 24.1-15.77 32.09-17.33 3.77-.73 6.48-4.05 6.48-7.88Z"
          className="cls-prop53"
        />
        <rect
          width={145.07}
          height={19.29}
          x={354.3}
          y={1474.6}
          className="cls-prop56"
          rx={9.64}
          ry={9.64}
        />
        <path
          d="M371.05 1368.92h1.76c12.56 0 22.75 10.2 22.75 22.75v43.16c0 12.56-10.2 22.75-22.75 22.75h-1.76v-88.67Z"
          className="cls-prop56"
        />
        <path
          d="M395.56 1391.68v43.16c0 12.57-10.19 22.75-22.75 22.75h-1.76v-3.32c10.67-1.49 18.89-10.65 18.89-21.73v-38.57c0-11.08-8.21-20.25-18.89-21.73v-3.32h1.76c12.57 0 22.75 10.19 22.75 22.75Z"
          className="cls-prop51"
        />
        <path
          d="M482.61 1457.59h-1.82c-12.59 0-22.81-10.22-22.81-22.81v-43.04c0-12.59 10.22-22.81 22.81-22.81h1.82v88.67Z"
          className="cls-prop56"
        />
        <path
          d="M499.36 1484.24c0-5.33-4.32-9.64-9.65-9.64H363.93a9.647 9.647 0 0 0-8.81 5.71h127.89c3.7 0 6.69 3 6.69 6.7 0 1.85-.75 3.52-1.96 4.74a6.665 6.665 0 0 1-4.73 1.96H362.08c.6.12 1.21.18 1.85.18h125.78c2.66 0 5.07-1.08 6.82-2.83s2.83-4.16 2.83-6.82ZM458.04 1391.68v43.16c0 12.57 10.19 22.75 22.75 22.75h1.76v-3.32c-10.67-1.49-18.89-10.65-18.89-21.73v-38.57c0-11.08 8.21-20.25 18.89-21.73v-3.32h-1.76c-12.57 0-22.75 10.19-22.75 22.75Z"
          className="cls-prop51"
        />
        <path
          d="M426.83 1369.69c-11 0-19.91 8.91-19.91 19.91v47.32c0 11 8.91 19.91 19.91 19.91s19.91-8.91 19.91-19.91v-47.32c0-11-8.91-19.91-19.91-19.91Z"
          className="cls-prop56"
        />
        <path
          d="M426.77 1369.69c-11 0-19.91 8.91-19.91 19.91v47.32c0 11 8.91 19.91 19.91 19.91 5.5 0 10.47-2.23 14.08-5.83 3.6-3.6 5.83-8.58 5.83-14.08v-47.32c0-11-8.91-19.91-19.91-19.91Zm15.97 61.36c0 4.41-1.79 8.4-4.68 11.29s-6.88 4.68-11.29 4.68c-8.82 0-15.97-7.15-15.97-15.97v-37.96c0-8.82 7.15-15.97 15.97-15.97s15.97 7.15 15.97 15.97v37.96Z"
          className="cls-prop51"
        />
        <ellipse
          cx={415.96}
          cy={1318.69}
          className="cls-prop52"
          rx={16.33}
          ry={5.09}
        />
        <ellipse
          cx={415.96}
          cy={1507.82}
          className="cls-prop52"
          rx={16.33}
          ry={5.09}
        />
        {children}
      </g>
    </svg>
  );
}
